// extracted by mini-css-extract-plugin
export var arrows = "_34-6";
export var decrementer = "_34-a";
export var disabled = "_34-4";
export var error = "_34-1";
export var hiddenText = "_34-b";
export var incrementer = "_34-9";
export var input = "_34-8";
export var inputWrapper = "_34-0";
export var leadingIcon = "_34-c";
export var readonly = "_34-3";
export var regular = "_34-7";
export var small = "_34-5";
export var warning = "_34-2";